import { http } from '@/http'

export default {
  list() {
    return http.get('/payroll-types')
  },
  listActive() {
    return http.get('/payroll-types/active')
  },
  get(id) {
    return http.get(`/payroll-types/${id}`)
  },
  save(data) {
    return http.post('/payroll-types', data)
  },
  update(id, data) {
    return http.put(`/payroll-types/${id}`, data)
  },
  changeStatus(id, status) {
    return http.put(`/payroll-types/${id}/status`, null, { params: { status } })
  },
}
